import axios from "@/plugins/axios";
import * as cash from "./cash";
import * as center from "./center";
import * as clover from "./clover";
import deposits from "./deposits";
import * as dshop from "./dshop";
import * as exchanges from "./exchanges";
import * as gifts from "./gifts";
import greenp from "./greenp";
import * as gshop from "./gshop";
import * as hunt from "./hunt";
import * as logout from "./logout";
import nshop from "./nshop";
import * as point from "./point";
import * as profile from "./profile";
import * as roulette from "./roulette";
import * as shop from "./shop";
import vaccount from "./vaccount";

export const me = {
    ...cash,
    ...center,
    ...clover,
    deposits,
    ...dshop,
    ...exchanges,
    ...gifts,
    greenp,
    ...gshop,
    ...hunt,
    ...logout,
    nshop,
    ...point,
    ...profile,
    ...roulette,
    ...shop,
    vaccount,

    withdraw() {
        return axios.put(`/api/v1/me/withdraw`).then((result) => result.data);
    },
    certificate(data) {
        return axios.put(`/api/v1/me/certificate`, data).then((result) => result.data);
    },
};
